import { IconProps } from './types';

export default function Clock({ className, strokeWidth }: IconProps) {
    return (
        <svg
            className={className}
            fill="none"
            height="25"
            viewBox="0 0 24 25"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            strokeWidth={strokeWidth}
        >
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="m12 21c4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8-4.41828 0-8 3.58172-8 8 0 4.4183 3.58172 8 8 8z" />
                <path d="m12 8.2002v4.8l3.2 1.6" />
            </g>
        </svg>
    );
}
